import { ApplicationDataBaseField } from './ApplicationDataBaseField';
import { Controller } from 'react-hook-form';
import { TextArea } from '@blueprintjs/core';
import { ApplicationDataFormFieldPath } from '../ApplicationDataForm/ApplicationDataFormSchema';
import { ApplicationDataFieldCommonProps } from './types';

function defaultFormatter(value: unknown) {
  return value ? String(value) : '-';
}

interface ApplicationDataTextAreaProps extends ApplicationDataFieldCommonProps {
  name: ApplicationDataFormFieldPath;
  formatter?: (value: unknown) => string;
}

export const ApplicationDataTextArea: React.FC<
  ApplicationDataTextAreaProps
> = ({ name, formatter = defaultFormatter, ...props }) => (
  <Controller
    name={name}
    render={({ field, fieldState }) => (
      <ApplicationDataBaseField
        errorMessage={
          fieldState.invalid ? fieldState.error?.message : undefined
        }
        valueElement={formatter(field.value as never)}
        inputElement={
          <TextArea
            name={field.name}
            onChange={field.onChange}
            onBlur={field.onBlur}
            value={field.value ?? ''}
            inputRef={field.ref}
            placeholder={props.placeholder}
            fill
          />
        }
        {...props}
      />
    )}
  />
);
